import axios from 'axios';
import { COOKIE_KEYS, storageKeys } from '../constants';
import { TReqRegister } from 'types';
import { getCookies } from 'utils';

const checkIdentify = async (
  phone: string,
): Promise<{
  isValidUser: boolean;
  isDisabledUser: boolean;
  message: string;
  phone: string;
}> => {
  return await axios
    .get(`accounts/check-user-identity/${encodeURIComponent(phone)}`)
    .then(function (response) {
      return response.data;
    });
};

const checkAuthentication = async (): Promise<{
  isAuthenticated: boolean;
}> => {
  return await axios
    .get(`accounts/check-authentication`)
    .then(function (response) {
      return response.data;
    });
};

const saveToken = ({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

  localStorage.setItem(storageKeys.ACCESS_TOKEN, accessToken);
  localStorage.setItem(storageKeys.REFRESH_TOKEN, refreshToken);
};

const signup = async (
  body: TReqRegister,
  token: string,
): Promise<{ id: number }> => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios
    .post(`accounts/register`, body, config)
    .then(function (response) {
      return response.data;
    });

  saveToken(res);

  return res;
};

const login = async (
  token: string,
  fcmToken?: string,
  subscriptionId?: string | null,
  lineSessionToken?: string,
): Promise<void> => {
  const clientId = getCookies(COOKIE_KEYS.CLIENT_ID);
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      clientId,
      fcmToken,
      subscriptionId,
    },
  };
  const res = await axios
    .post(`accounts/login`, { lineSessionToken }, config)
    .then(function (response) {
      return response.data;
    });

  saveToken(res);
};

const logout = async (
  fcmToken?: string,
  subscriptionId?: string | null,
  clientId?: string | null,
): Promise<void> => {
  return await axios
    .get(`accounts/logout`, {
      params: {
        fcmToken,
        subscriptionId,
        clientId,
      },
    })
    .then(function (response) {
      return response.data;
    });
};

export { checkAuthentication, checkIdentify, saveToken, signup, login, logout };
